import { Outlet } from 'react-router-dom';

import { AuthProvider } from '@/components/providers/auth-provider';

import { Sidebar } from './sidebar';

/**
 * Authenticated shell — sidebar + main content. AuthProvider wraps the
 * outlet HERE (rather than the app root) so router hooks work: the
 * provider uses `useNavigate`/`useLocation`, which need to be inside a
 * router context. Everything under this layout is behind auth.
 */
export function AppLayout(): JSX.Element {
  return (
    <AuthProvider>
      <div className="flex h-screen bg-mb-bg">
        <Sidebar />
        <main className="flex-1 overflow-hidden flex flex-col">
          <Outlet />
        </main>
      </div>
    </AuthProvider>
  );
}
